<section (click)="handleOpen($event)" class="relative md:hidden">
    <ng-container *ngTemplateOutlet="content" />
</section>

<section class="hidden relative md:flex">
    <div [cdkMenuTriggerFor]="menu">
        <ng-container *ngTemplateOutlet="content" />
    </div>
</section>

<ng-template #content>
    <div
        class="flex gap-2 items-center px-3 py-2 rounded-xl border transition-all duration-300 ease-in-out cursor-pointer select-none w-fit border-primary-300 bg-primary-50"
    >
        <app-icon
            size="sm"
            name="mynaui:heart-home-solid"
            class="text-primary"
        />
        <p
            class="text-sm text-primary sm:block w-fit line-clamp-1 overflow-hidden md:w-[8rem]"
        >
            @if (currentCenter(); as center) {
                {{ center.name }}
            } @else {
                소속된 센터가 없습니다.
            }
        </p>
        <app-icon
            name="material-symbols:keyboard-arrow-down-rounded"
            class="text-primary"
            size="sm"
        />
    </div>
</ng-template>

<ng-template #menu>
    <div
        class="flex overflow-hidden flex-col gap-4 bg-white rounded-xl shadow-lg"
        cdkMenu
    >
        <app-select-center-content
            [currentCenter]="currentCenter()!"
            (select)="handleSelect($event!)"
            [centers]="centers() || []"
        />
    </div>
</ng-template>
